import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Grid from "../grid/grid.js"

const PartnerQuery = ({ blok }) => {
  const { allStoryblokEntry } = useStaticQuery(
    graphql`
      query {
        allStoryblokEntry(
          sort: { slug: ASC }
          filter: { field_component: { eq: "partners" } }
        ) {
          nodes {
            name
            uuid
            content
          }
        }
      }
    `
  )

  const partners = allStoryblokEntry?.nodes?.map(node => ({
    _uid: node.uuid,
    grid_content: [
      {
        ...node,
        _uid: node.uuid,
        component: "partner",
        content: JSON.parse(node.content),
      },
    ],
  }))

  blok = {
    ...blok,
    class: "partner_query",
    per_row: 3,
    row_gap: 60,
    grid_items: partners,
  }

  return <Grid blok={blok}></Grid>
}

export default PartnerQuery
